module.exports = __webpack_public_path__ + "static/media/hollywood.b5e937ec.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/games/hollywood.png
// module id = 2397
// module chunks = 7